"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const StorefrontCMSPage_1 = __importDefault(require("./StorefrontCMSPage"));
const client_1 = require("@apollo/client");
const MapmakerApi_1 = require("../../client/MapmakerApi");
(0, client_1.gql) `
  query privacyPolicy {
    storefrontShop {
      privacyPolicy {
        title
        body
      }
    }
  }
`;
function PrivacyPolicyPage() {
    const { data, loading } = (0, MapmakerApi_1.usePrivacyPolicyQuery)();
    return ((0, jsx_runtime_1.jsx)(StorefrontCMSPage_1.default, { page: data === null || data === void 0 ? void 0 : data.storefrontShop.privacyPolicy, loading: loading }));
}
exports.default = PrivacyPolicyPage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJpdmFjeVBvbGljeVBhZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9wb2xpY2llcy9Qcml2YWN5UG9saWN5UGFnZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsNEVBQTBDO0FBQzFDLDJDQUFxQztBQUNyQywwREFBaUU7QUFFakUsSUFBQSxZQUFHLEVBQUE7Ozs7Ozs7OztDQVNGLENBQUM7QUFFRixTQUF3QixpQkFBaUI7SUFDdkMsTUFBTSxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsR0FBRyxJQUFBLG1DQUFxQixHQUFFLENBQUM7SUFDbEQsT0FBTyxDQUNMLHVCQUFDLDJCQUFPLElBQUMsSUFBSSxFQUFFLElBQUksYUFBSixJQUFJLHVCQUFKLElBQUksQ0FBRSxjQUFjLENBQUMsYUFBYSxFQUFFLE9BQU8sRUFBRSxPQUFPLEdBQUksQ0FDeEUsQ0FBQztBQUNKLENBQUM7QUFMRCxvQ0FLQyJ9